import type { MenuGroup, MenuItem } from './menu-types';

import { isMenuGroup } from './menu-types';
import { isMenuLinkActive } from './route-branch';

/**
 * Режим экземпляра панели подразделов на десктопе:
 * - `pinned` — закреплена группой текущего route и раздвигает контент;
 * - `collapsed` — закреплённая панель с нулевой шириной, остаётся кнопка раскрытия;
 * - `preview` — оверлей поверх контента для другой группы (клик по иконке рейла).
 */
export type PanelMode = 'pinned' | 'collapsed' | 'preview';

/** Группа меню по id; `null`, если id пуст, не найден или принадлежит листу. */
export const findMenuGroup = (items: MenuItem[], id: string | null): MenuGroup | null => {
  const item = items.find((menuItem) => menuItem.id === id);

  return item && isMenuGroup(item) ? item : null;
};

/**
 * Группа, в чьей ветке лежит текущий route. Листья верхнего уровня (Запись, Клиенты,
 * и т.д.) группе не принадлежат — для них панель не открывается (`null`).
 * Правило ветки общее с подсветкой пункта, см. `route-branch.ts`.
 */
export const findActiveGroupId = (items: MenuItem[], routeName: string): string | null => {
  const group = items.find(
    (item) => isMenuGroup(item) && item.children.some((child) => isMenuLinkActive(child, routeName)),
  );

  return group ? group.id : null;
};
